import { createSelector } from 'reselect';
import { getIsCompanyLoading } from 'lib/selectors/getCompany';
import { getAreAnnotationsLoading } from 'lib/selectors/getAnnotations';
import { getIsInitialActivitySetPollLoading } from 'lib/selectors/getIsInitialActivitySetPollLoading';
import { getAreActivityTypesLoading } from 'lib/selectors/getActivityTypes';
import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';
import { getLaborTicketsLoading } from 'lib/selectors/getLaborTicketsLoading';

const getIsBaseAppDataLoading = createSelector(
  [
    (state) => {
      return state.loading;
    },
    (state) => {
      return state.shifts.loading;
    },
    getIsCompanyLoading,
    getAreAnnotationsLoading,
    getIsInitialActivitySetPollLoading,
    getAreActivityTypesLoading,
    getPostLaborUpdatesOnNats,
    getLaborTicketsLoading,
  ],
  (
    isInitialDataLoading,
    areShiftsLoading,
    isCompanyLoading,
    areAnnotationsLoading,
    isInitialActivitySetPollLoading,
    areActivityTypesLoading,
    natsFlowEnabled,
    laborTicketsLoading
  ) => {
    // NATS mode: wait for labor tickets instead of activity sets
    if (natsFlowEnabled) {
      return !!(
        isInitialDataLoading ||
        areShiftsLoading ||
        isCompanyLoading ||
        areAnnotationsLoading ||
        areActivityTypesLoading ||
        laborTicketsLoading
      );
    }

    return !!(
      isInitialDataLoading ||
      areShiftsLoading ||
      isCompanyLoading ||
      areAnnotationsLoading ||
      isInitialActivitySetPollLoading ||
      areActivityTypesLoading
    );
  }
);

const getBaseAppDataLoadingStates = createSelector(
  [
    (state) => {
      return state.loading;
    },
    (state) => {
      return state.shifts.loading;
    },
    getIsCompanyLoading,
    getAreAnnotationsLoading,
    getIsInitialActivitySetPollLoading,
    getAreActivityTypesLoading,
    getPostLaborUpdatesOnNats,
    getLaborTicketsLoading,
  ],
  (
    isInitialDataLoading,
    areShiftsLoading,
    isCompanyLoading,
    areAnnotationsLoading,
    isInitialActivitySetPollLoading,
    areActivityTypesLoading,
    natsFlowEnabled,
    laborTicketsLoading
  ) => {
    // NATS mode: include labor tickets loading instead of activity set
    if (natsFlowEnabled) {
      return {
        initialData: isInitialDataLoading,
        shifts: areShiftsLoading,
        company: isCompanyLoading,
        annotations: areAnnotationsLoading,
        activityTypes: areActivityTypesLoading,
        laborTickets: laborTicketsLoading,
      };
    }

    return {
      initialData: isInitialDataLoading,
      shifts: areShiftsLoading,
      company: isCompanyLoading,
      annotations: areAnnotationsLoading,
      latestActivitySet: isInitialActivitySetPollLoading,
      activityTypes: areActivityTypesLoading,
    };
  }
);

export { getIsBaseAppDataLoading, getBaseAppDataLoadingStates };
